/**
 * Search Niche Configuration
 */

import { MARKETPLACES } from './marketplaces.constants';

export const SEARCH_NICHE_CONFIG = {
  // Default filters
  defaultFilters: {
    keyword: '',
    marketplace: 'US',
    exactKeyword: false,
  },

  // Marketplace options
  marketplaces: MARKETPLACES,
  // Translation namespaces
  translationNamespace: 'searchNiche',

  pollInterval: 10000, // Poll interval in ms

  DEBOUNCE_SAVE_LS_DELAY: 1500, // Debounce delay for saving to localStorage in ms
  ANALYSIS_ID_STORAGE_KEY: 'search_niche_analysis_id', // localStorage key for analysis ID
  FORM_STATE_STORAGE_KEY: 'search_niche_form_state', // localStorage key for form state
  SEARCH_STAGE_STORAGE_KEY: 'searchNiche_stage', // localStorage key for search stage
  MAX_STAGE: 5, // Maximum stage value
};
